import PageLayer from "@Layouts/views/PageLayer";
import DrawLayer from "@DataPages/components/Draw/DrawLayer";

// Icons
import DrawIcon from "@/assets/icons/dataPages/draw/draw-icon.svg";

export default function Draw() {
	return (
		<PageLayer title="Draw and Overdraw" icon={DrawIcon}>
			<DrawLayer />
		</PageLayer>
	);
}
